<template>
  <div
    class="modal fade"
    id="myModal2"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-subscription">
        <button
          type="button"
          class="btn-close-modern"
          data-dismiss="modal"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body login-modal-body">
          <template v-if="!showResetPass">
            <form @submit.prevent="login">
              <h3 class="fw-bold text-center mb-3">Iniciar Sesión</h3>
              <input name="utf8" type="hidden" value="✓" />
              <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mb-3">
                <div class="login-modal-label">
                  <label class="form-label mb-0 fw-bold" for="loginModalEmail">Correo</label>
                </div>
                <div class="flex-grow-1 w-100">
                  <input
                    id="loginModalEmail"
                    v-model="formUsername"
                    placeholder="E-mail"
                    class="form-control"
                    type="email"
                    autocomplete="username"
                  />
                </div>
              </div>
              <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mb-3">
                <div class="login-modal-label">
                  <label class="form-label mb-0 fw-bold" for="loginModalPassword">Clave</label>
                </div>
                <div class="flex-grow-1 w-100">
                  <input
                    id="loginModalPassword"
                    v-model="formPassword"
                    placeholder="Contraseña"
                    class="form-control"
                    type="password"
                    autocomplete="current-password"
                  />
                </div>
              </div>
              <p class="text-center text-muted small mb-3">
                <a href="#" class="login-modal-link" @click.prevent="setResetPassTrue()"
                  >¿Olvidaste tu contraseña?</a
                >
              </p>

              <div class="mimi_field d-flex flex-wrap justify-content-center gap-0">
                <input
                  type="submit"
                  class="submit btn-al btn-al-lg btn-al-celeste-solid btn-secciones button-left-subscription"
                  value="Acceder"
                  id="loginModalSubmitLogin"
                />
                <button
                  type="button"
                  class="btn-al btn-al-lg btn-al-azul-solid btn-secciones button-right-subscription"
                  data-dismiss="modal"
                  data-bs-dismiss="modal"
                >
                  Cerrar
                </button>
              </div>
            </form>
          </template>
          <template v-else>
            <form @submit.prevent="forgetPassword">
              <h3 class="fw-bold text-center mb-3">Recuperar Contraseña</h3>
              <input name="utf8" type="hidden" value="✓" />
              <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-2 mb-3">
                <div class="login-modal-label">
                  <label class="form-label mb-0 fw-bold" for="loginModalEmailReset">Correo</label>
                </div>
                <div class="flex-grow-1 w-100">
                  <input
                    id="loginModalEmailReset"
                    v-model="formUsername"
                    placeholder="E-mail"
                    class="form-control"
                    type="email"
                    autocomplete="username"
                  />
                </div>
              </div>
              <template v-if="loadingResetPass"> Cargando... por favor, espere </template>

              <div class="mimi_field d-flex flex-wrap justify-content-center gap-0 mt-3">
                <input
                  type="submit"
                  class="submit btn-al btn-al-lg btn-al-celeste-solid btn-secciones button-left-subscription"
                  value="Reestablecer"
                  id="loginModalSubmitReset"
                />
                <button
                  type="button"
                  @click="setResetPassFalse()"
                  class="btn-al btn-al-lg btn-al-azul-solid btn-secciones button-right-subscription"
                >
                  Volver
                </button>
              </div>
            </form>
          </template>
          <div class="text-center mt-4 mb-2">
            <p class="mb-0 small">
              Si aún no posee una cuenta puede registrarse
              <router-link class="login-modal-link" to="/registrar">aquí</router-link>.
            </p>
          </div>
          <template v-if="loadingBar">
            <div class="w-100 text-center mt-2">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 100%"
                ></div>
              </div>
            </div>
          </template>
          <div :class="[loginMessage === '' ? 'd-none' : 'alert alert-success']" role="alert">
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              data-bs-dismiss="alert"
              @click="hideMessages()"
            >
              &times;</button
            ><strong>{{ loginMessage }}</strong>
          </div>
          <div :class="[errorLoginMessage === '' ? 'd-none' : 'alert alert-danger']" role="alert">
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              data-bs-dismiss="alert"
              @click="hideMessages()"
            >
              &times;</button
            ><strong>{{ errorLoginMessage }}</strong>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { generateTokenBodyRequest, setTokens } from '@/helpers/localStorage.helpers';
import { postLogin, putPassword } from '@/service/account.service';

export default {
  name: 'LoginModal',
  data() {
    return {
      formUsername: '',
      formPassword: '',
      loginMessage: '',
      errorLoginMessage: '',
      showResetPass: false,
      loadingResetPass: false,
      loadingBar: false,
    };
  },
  methods: {
    hideMessages() {
      this.loginMessage = '';
      this.errorLoginMessage = '';
    },
    setResetPassTrue() {
      this.showResetPass = true;
    },
    setResetPassFalse() {
      this.showResetPass = false;
    },
    login() {
      this.loadingBar = true;
      const body = generateTokenBodyRequest(this.formUsername, this.formPassword);
      postLogin(body)
        .then(response => {
          this.loginMessage = 'Sesión Iniciada correctamente. Se están cargando sus datos...';
          setTokens(response.data.access_token, response.data.refresh_token);
          this.loadingBar = false;
          location.reload();
        })
        .catch(error => {
          this.loadingBar = false;
          this.errorLoginMessage =
            'Clave y/o usuario no coinciden. Ingrese nuevamente su usuario y contraseña.';
        });
    },
    forgetPassword() {
      this.showResetPass = true;
      this.loadingResetPass = true;
      var json_data = {
        cli_username: this.formUsername,
      };
      putPassword(json_data)
        .then(response => {
          this.loadingResetPass = false;
          this.showResetPass = false;
          this.loginMessage =
            '¡Exito! Su contraseña ha sido restablecida correctamente. Por favor, verifique su correo electrónico.';
          this.formUsername = '';
          this.formPassword = '';
        })
        .catch(error => {
          this.loadingResetPass = false;
          this.loginMessage = '';
          this.errorLoginMessage =
            'Hubo un problema al generar la nueva contraseña. Verifique si ingreso su usuario correctamente e intentelo nuevamente.';
        });
    },
  },
};
</script>

<style>
.login-modal-label {
  min-width: 4.5rem;
  text-align: left;
}
@media (min-width: 576px) {
  .login-modal-label {
    text-align: right;
  }
}

#myModal2 .login-modal-body .login-modal-link,
#myModal2 .login-modal-body .login-modal-link:hover,
#myModal2 .login-modal-body a.login-modal-link {
  text-decoration: none !important;
  color: var(--primary-bgcolor) !important;
}

#myModal2 .login-modal-body .form-control {
  border: 1px solid var(--secondary-color);
  color: var(--secondary-bgcolor);
  border-radius: 0.25rem;
}

#myModal2 .login-modal-body .form-control:focus {
  border-color: var(--primary-bgcolor);
  box-shadow: 0 0 0 0.12rem color-mix(in srgb, var(--primary-bgcolor) 28%, transparent);
}
</style>
